import StudentPanelsConfig from '../../student-container/student-panels.config';

const GradV3Config = {
  title: StudentPanelsConfig.GRAD_PLANNING.human,
  paths: [
    'student.gradPlanningDetails.plannedDiplomaType',
    'student.gradPlanningDetails.plannedGraduationDate',
    'student.gradPlanningDetails.schoolVerifiedSafetyNetEligibility',
    'student.gradPlanningDetails.plannedEndorsements',
    'student.gradPlanningDetails.plannedCreds',
  ],
};

export default GradV3Config;
